import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#4CAF50' },
    secondary: { main: '#f44336' },
    error: { main: '#f44336' },
    warning: { main: '#ff9800' },
    background: { default: '#f9fafb' },
  },
  typography: {
    fontFamily: 'Speedee, Arial, sans-serif',
    h6: {
      fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
      fontWeight: 500,
    },
    body2: {
      fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
    },
    caption: {
      fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.875rem' },
    },
  },
  components: {
    // MuiAppBar: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: '#ffffff',
    //       boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    //       color: '#333',
    //       borderRadius: { xs: 0, sm: '0 0 12px 0' },
    //     },
    //   },
    // },
     MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
          borderBottom: 'none !important',
          color: '#333 !important',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: { xs: '4px 8px', sm: '6px 12px', md: '8px 16px' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          height: { xs: 16, sm: 18, md: 20 },
          fontSize: { xs: '0.55rem', sm: '0.65rem', md: '0.75rem' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: { xs: '2px 4px', sm: '3px 6px', md: '4px 8px' },
          fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.875rem' },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          maxWidth: '100%',
          overflowX: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: '#bdbdbd #f1f1f1',
          '&::-webkit-scrollbar': { height: '8px' },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#bdbdbd',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
          },
        },
      },
    },
  },
});

export default theme;